import { RefundableTickets } from 'features/RefundableTickets';

const RefundableTicketsPage = () => <RefundableTickets />;

export default RefundableTicketsPage;
